// [UAT-R1 Finding 1 / UAT-UX item 2] Client-side-first logout — extracted from Sidebar so other
// surfaces (the upload modal's "session needs refreshing" affordance) reuse the EXACT same flow
// instead of duplicating it. The server call is best-effort (stateless JWT — nothing to revoke
// server-side yet) and must NEVER block the local sign-out.
import API from "../constants/API";
import { authHeader } from "./mainfunction";
import { USER_SIGN_OUT_URL } from "./url";
import { SIGNIN_ROUTE } from "../constants/RoutePaths";
import { clearLocalStorageKeepingTheme } from "../context/ThemeContext";

export const logOutUser = async (): Promise<void> => {
  try {
    await API({
      method: "POST",
      url: USER_SIGN_OUT_URL,
      headers: authHeader(),
      timeout: 3000, // a slow/unreachable API must not hold the user hostage
    });
  } catch {
    // Best-effort only — proceed with the client-side logout regardless.
  }
  try {
    // Drops the sticky per-user caches (ezc.featureFlags / ezc.permissions /
    // ezc.queueAssignments) plus invoiceNav_* — all sessionStorage here is session state.
    sessionStorage.clear();
  } catch {
    // Storage unavailable — nothing cached to leak.
  }
  // AUTH_TOKEN + identity keys — route guards now bounce to /signin. The dark-mode preference
  // is device-level appearance, not session state — it survives the clear ([UAT-UX item 3]).
  clearLocalStorageKeepingTheme();
  // Hard document replace (not history()) so redux + every context reset and the
  // authenticated page is dropped from history — Back cannot resurrect the session.
  window.location.replace(SIGNIN_ROUTE);
};
